import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboad from "./pages/dashboad/dashboad";
import CreateTable from "./pages/table/CreateTable";
import Category from "./pages/category/category";
import CreateUser from "./pages/user/CreateUser";
import Login from "./pages/login/login";
import Order from "./pages/order/Order";
import Report from "./pages/report/report";
import ProtectedRoute from "./components/ProtectedRoute";
import OrderPage from "./pages/order/OrderPage";
import CreateItems from "./pages/items/CreateItems";
import OrderTransfer from "./pages/order/OrderTransfer";
import Sales from "./pages/sales/Sales";
import Members from "./pages/members/Members";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboad />
            </ProtectedRoute>
          }
        />
        <Route
          path="/take_order"
          element={
            <ProtectedRoute>
              <Order />
            </ProtectedRoute>
          }
        />
        <Route
          path="take_order/:slug"
          element={
            <ProtectedRoute>
              <OrderPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="sales/"
          element={
            <ProtectedRoute>
              <Sales />
            </ProtectedRoute>
          }
        />
        <Route
          path="members/"
          element={
            <ProtectedRoute>
              <Members />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tables"
          element={
            <ProtectedRoute>
              <CreateTable />
            </ProtectedRoute>
          }
        />
        <Route
          path="/items"
          element={
            <ProtectedRoute>
              <CreateItems />
            </ProtectedRoute>
          }
        />
        <Route
          path="/category"
          element={
            <ProtectedRoute>
              <Category />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order"
          element={
            <ProtectedRoute>
              <Order />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report"
          element={
            <ProtectedRoute>
              <Report />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order_transfer"
          element={
            <ProtectedRoute>
              <OrderTransfer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Users"
          element={
            <ProtectedRoute>
              <CreateUser />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
